import axios, { AxiosInstance } from "axios";
import React, { createContext, useContext } from "react";

interface ApiContextData {
  api: AxiosInstance;
}

const ApiContext = createContext<ApiContextData>({} as ApiContextData);

export const ApiProvider: React.FC = ({ children }) => {
  const api = axios.create({ baseURL: process.env.REACT_APP_API });

  return (
    <ApiContext.Provider value={{ api }}>
      {children}
    </ApiContext.Provider>
  );
};

export function useApi(): ApiContextData {
  const context = useContext(ApiContext);

  if (!context) throw new Error("useApi must be used within an ApiProvider");

  return context;
}
